import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Box, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AddDialog } from "./Dialog";

export const AddGroup = ({ groups }) => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<>
			<Tooltip
				title={
					<Typography variant="p" sx={{ fontSize: "9pt" }} component="span">
						{t("add_new_mailing_group")}
					</Typography>
				}
				placement="top"
			>
				<Box
					sx={{
						width: "52px",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
					onClick={handleClickOpen}
				>
					<AddCircleIcon
						sx={{ color: "#63c29a", fontSize: 32, cursor: "pointer" }}
					/>
				</Box>
			</Tooltip>
			<AddDialog open={open} onClose={handleClose} groups={groups} />
		</>
	);
};
